import commonApi from "@/api/common.js";
export default {
  state: {
    token: "",
    tmpUti: "",
    userInfo: {},
    addressList:[]
  },
  mutations: {
    updateUser(state, data) {
      state.token = data.token;
      state.userInfo = data.userInfo;
    },
    updateAddress(state,data){
      for (let i in data){
        if( data[i]['default'] === 1){
          data[i]['active'] = 1;
        }else{
          data[i]['active'] = 0;
        }
        data[i]['move'] = 0;
      }
      state.addressList = data;
    },
    editAddrState(state,arr){
      let address = state.addressList;
      for(let key in arr){
        for (let i in address){
          address[i][key]=arr[key];
        }
      }
      state.addressList=address;
    },
    delAddrState(state,data){
      state.addressList.splice(data.index,1);
    },
    addAddressState(state,arr){
      state.addressList.push(arr);
    },
    loginOut(state){
      state.token = '';
      state.userInfo = '';
    },
    setTmpUri(state,uri){
      state.tmpUri = uri;
    },
    delTmpUri(state){
      state.tmpUri = '';
    }
  },
  getters: {
    getUserInfo(state) {
      return state.userInfo;
    },
    getAddrList(state){
      return state.addressList;
    },
    getToken(state) {
      return state.token;
    },
    getTmpUri(state){
      return state.tmpUri;
    }
  },
  actions: {
    async login({ commit },data) {
      await commonApi.login(data).then(function(response) {
        if(response.code == 200){
            commit("updateUser",response.data);
        }
      });
    },
    async getAddress({commit},token){
      await commonApi.addressList(token).then(function(response) {
        if(response.code == 200){
          commit("updateAddress",response.data);
        }
      });
    },
    async addAddress({commit},address){
      await commonApi.addAddressApi(address).then(function(response){
        if(response.code == 200){
          let data = response.data;
          data.active = 0;
          data.move = 0;
          if(data.default == 1){
            commit("editAddrState",{default:0,active:0});
            data.active = 1;
          }
          commit("addAddressState",data);
        }
      })
    },
    async delAddress({commit},data){
      await commonApi.delAddressApi(data).then((response)=>{
        if(response.code == 200){
          commit("delAddrState",data);
        }
      })
    },
    tmpUri({commit},uri){
      commit("setTmpUri",uri);
    },
    async editAddr({commit},arr){
      let aid = arr.aid;
      await commonApi.updateAddrApt()

      commit("editAddrState",arr);
    },
    delTmpUri({commit}){
      commit("delTmpUri");
    },
    loginOut({commit}){
      commit("loginOut");
    }
  }
};
